const pageHeader = document.querySelector(".trc-h.trc");

let headerHeight = "0px";
if (pageHeader) {
  headerHeight = getComputedStyle(pageHeader).height;
}

const tocWrapper = document.querySelector(".toc-wrapper");

window.addEventListener("scroll", function () {
  if (!pageHeader || !tocWrapper) {
    return;
  }

  const isHeaderHidden = pageHeader.classList.contains("trc-h--hidden");

  if (isHeaderHidden) {
    tocWrapper.style.top = "";
  } else {
    tocWrapper.style.top = parseInt(headerHeight, 10) + 16 + "px";
  }
});

const articleHtml = document.querySelector(".article-template__content");

let titles = [];
if (articleHtml) {
  titles = Array.prototype.slice
    .call(articleHtml.children)
    .filter(function (item) {
      return item.tagName && item.tagName.startsWith("H");
    });
}

const hierarchy = buildHierarchy(titles);

const tocList = document.querySelector("#table-of-content ul");
const tocHandle = document.querySelector(".toc-handle");

if (tocHandle) {
  tocHandle.addEventListener("click", function () {
    const isOpened = tocHandle.classList.contains("opened");

    if (!tocList || !tocList.parentElement) {
      return;
    }

    if (isOpened) {
      tocList.parentElement.style.height = "0px";
      tocHandle.classList.remove("opened");
    } else {
      tocList.parentElement.style.height = "auto";
      tocHandle.classList.add("opened");
    }
  });
}

if (tocList) {
  hierarchy.forEach(function (hierarchyItem) {
    const tocListItem = createTOCListItem({ hierarchyItem: hierarchyItem });
    if (tocListItem) {
      tocList.append(tocListItem);
    }
  });
}

function buildHTMLElementNode(element) {
  return {
    element: element,
    children: [],
    addChild: function (child) {
      this.children.push(child);
    },
  };
}

function buildHierarchy(titles) {
  const root = buildHTMLElementNode(null);
  let hierarchyStack = [{ node: root, level: 0 }];

  for (const title of titles) {
    const level = parseInt(title.tagName.slice(1), 10);
    const node = buildHTMLElementNode(title);

    while (
      hierarchyStack.length > 0 &&
      hierarchyStack[hierarchyStack.length - 1].level >= level
    ) {
      hierarchyStack.pop();
    }

    if (hierarchyStack.length > 0) {
      hierarchyStack[hierarchyStack.length - 1].node.addChild(node);
    }

    hierarchyStack.push({ node: node, level: level });
  }

  return root.children;
}

function createTOCListItem({ hierarchyItem }) {
  const heading = hierarchyItem.element;

  if (!heading || !heading.innerText) {
    return;
  }

  heading.id = encodeURIComponent(heading.innerText);

  const li = document.createElement("li");
  const a = document.createElement("a");

  a.href = "javascript:void(0);";
  a.innerText = heading.innerText.replace(/(\r\n|\n|\r)/g, "");
  li.appendChild(a);

  if (hierarchyItem.children.length > 0) {
    li.classList.add("toc--list-item__with-children");

    const childUl = document.createElement("ul");
    childUl.classList.add("toc--list-item__children");

    hierarchyItem.children.forEach(function (child) {
      const childLi = createTOCListItem({ hierarchyItem: child });
      if (childLi) {
        childUl.appendChild(childLi);
      }
    });

    li.appendChild(childUl);

    li.addEventListener("click", function () {
      const isOpened = childUl.classList.contains("open");
      childUl.classList.toggle("open");
      childUl.style.height = isOpened ? 0 : "auto";
      li.classList.toggle("toc--list-item__with-children__opened");
    });
  }

  a.addEventListener("click", function (e) {
    e.stopPropagation();

    const headerOffset = 124;
    const elementPosition = heading.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  });

  return li;
}